import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateSystemMessageFormWrapper = styled.div`
  .add-form-container {
    padding: 0 0 30px 16px;
    ${responsive.MOBILE`
        padding: 0px 16px 16px 16px;
    `};
  }

  .title {
    padding-bottom: 0px;
  }

  .country-language-grid {
    padding-top: 24px;
    .max-width {
      max-width: 250px;
    }
    ${responsive.MOBILE`
      padding-top: 0px;
    `}
  }

  .checkbox-container {
    border-top: 1px dashed ${COLORS.primary_light_blue4};
    padding: 24px 0 24px 16px;
    ${responsive.MOBILE`
        padding: 16px;
    `};

    .select-preferences {
      color: ${COLORS.cirrus_black};
    }
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
    padding-right: 16px;
    ${responsive.MOBILE`
      padding-right: 0px;
    `}
  }
`;
